import crypto from 'crypto';

/**
 * @param {number} length Number of character on the random key
 * @returns {string} randomKey
 */
const randomKeyGenerator = (length = 8) =>
  crypto.randomBytes(length).toString('hex');

export default randomKeyGenerator;
